import { render, staticRenderFns } from "./EndCard.vue?vue&type=template&id=802a95ec&"
import script from "./EndCard.vue?vue&type=script&lang=js&"
export * from "./EndCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports